import { ItemService } from './../item.service';
import { Component, OnInit, Input } from '@angular/core';
import { Item } from "../models/item";
import { trigger, state, transition, animate, style } from "@angular/animations";

@Component({
  selector: 'app-dant',
  templateUrl: './dant.component.html',
  styleUrls: ['./dant.component.css'],
  animations: [
    trigger('changeState', [
      state('state1', style({
        backgroundColor: 'green',
        transform: 'scale(1)'
      })),
      state('state2', style({
        backgroundColor: 'red',
        transform: 'translate(540px,0px)',
      })),
      transition('*=>state1', animate('300ms')),
      transition('*=>state2', animate('200ms')),
    ])
  ]
})
export class DantComponent implements OnInit {

  @Input() currentState;


  dants: Item[];
  constructor(private ItemService: ItemService) { }

  ngOnInit() {
    this.ItemService.getDants().subscribe(dants => {
      this.dants = dants;
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/dant/dant.component.ts